import { alpha } from "@mui/material/styles";

export function ambientBackgroundSx(theme) {
    const isDark = theme.palette.mode === "dark";
    const primary = theme.palette.primary.main;

    return {
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
        overflow: "hidden",
        background: isDark
            ? `radial-gradient(ellipse 70% 45% at 0% 0%, ${alpha(primary, 0.09)} 0%, transparent 55%), linear-gradient(${alpha(primary, 0.025)} 1px, transparent 1px), linear-gradient(90deg, ${alpha(primary, 0.025)} 1px, transparent 1px)`
            : `radial-gradient(ellipse 70% 45% at 0% 0%, ${alpha(primary, 0.04)} 0%, transparent 55%)`,
        backgroundSize: isDark ? "auto, 32px 32px, 32px 32px" : undefined,
    };
}

/** Standard content panel — no accent bar, minimal motion. */
export function panelCardSx(theme, { hover = false } = {}) {
    return {
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        transition: hover ? "border-color 0.2s ease, box-shadow 0.2s ease" : undefined,
        ...(hover
            ? {
                "&:hover": {
                    borderColor: alpha(theme.palette.primary.main, 0.35),
                    boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.25 : 0.06)}`,
                },
            }
            : {}),
    };
}

export function glowCardSx(theme, { accent = "primary", hover = true, accentBar = false } = {}) {
    const base = panelCardSx(theme, { hover });
    if (!accentBar) return base;

    const c = theme.palette[accent]?.main || theme.palette.primary.main;
    return {
        ...base,
        ...(hover
            ? {
                "&:hover": {
                    ...base["&:hover"],
                    boxShadow: `0 6px 24px ${alpha(c, theme.palette.mode === "dark" ? 0.15 : 0.08)}`,
                },
            }
            : {}),
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 2,
            background: theme.palette.primary.main,
            opacity: 0.6,
        },
    };
}

export function iconBadgeSx(theme, color = "primary") {
    const c = theme.palette[color]?.main || theme.palette.primary.main;
    return {
        width: 36,
        height: 36,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        background: alpha(c, 0.12),
        border: `1px solid ${alpha(c, 0.22)}`,
        color: c,
    };
}

export function pageEnterSx() {
    return {
        animation: "pageEnter 0.3s ease-out both",
        "@keyframes pageEnter": {
            from: { opacity: 0 },
            to: { opacity: 1 },
        },
    };
}
